<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path
      d="M11.5075 8.01728C11.7796 7.72783 12.2208 7.72783 12.4929 8.01728L18.9961 14.9349C19.2682 15.2244 19.2682 15.6937 18.9961 15.9831C18.724 16.2726 18.2828 16.2726 18.0107 15.9831L12.0002 9.58955L5.98966 15.9831C5.71756 16.2726 5.27638 16.2726 5.00428 15.9831C4.73217 15.6937 4.73217 15.2244 5.00428 14.9349L11.5075 8.01728Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconChevronUp',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
